import types from '../types/help'
import {Map, List} from 'immutable'
import {User as UserTypes} from '../../../state/types'

const initialRoot = Map({
  categories: List(),
  faqs: List(),
  selectedCategory: 0,
  loadingCategories: false,
  loadingFaqs: false,
  name: '',
  defaultName: '',
  email: '',
  defaultEmail: '',
  message: '',
  showContactSuccessMessage: false,
  loadingContact: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.FETCH_CATEGORIES:
      return state.merge({
        loadingCategories: true,
        error: '',
      })
    case types.FETCH_CATEGORIES_SUCCESS:
      return state.merge({
        loadingCategories: false,
        categories: List(action.payload.categories),
      })
    case types.FETCH_CATEGORIES_FAIL:
      return state.merge({
        loadingCategories: false,
        error: action.payload.error,
      })
    case types.FETCH_FAQS:
      return state.merge({
        selectedCategory: action.payload.categoryID,
        faqs: List(),
        loadingFaqs: true,
        error: '',
      })
    case types.FETCH_FAQS_SUCCESS:
      return state.merge({
        loadingFaqs: false,
        faqs: List(action.payload.faqs),
      })
    case types.FETCH_FAQS_FAIL:
      return state.merge({
        loadingFaqs: false,
        error: action.payload.error,
      })
    case UserTypes.SET_FIRST_TIME:
      return state.merge({
        name: action.user.name,
        email: action.user.email,
        defaultName: action.user.name,
        defaultEmail: action.user.email,
        message: '',
        showContactSuccessMessage: false,
      })
    case '@@router/LOCATION_CHANGE':
      if (action.payload.pathname === '/ayuda/contacto') {
        return state.merge({
          name: state.get('defaultName'),
          email: state.get('defaultEmail'),
          error: '',
          message: '',
          showContactSuccessMessage: false,
        })
      }
      return state.set('showContactSuccessMessage', false)
    case UserTypes.UPDATE_USER_INFO_SUCCESS:
      let newState = state.merge({
        defaultName: action.payload.user.name,
        defaultEmail: action.payload.user.email,
      })
      if (state.get('name') === '') newState = newState.set('name', action.payload.user.name)
      if (state.get('email') === '') newState = newState.set('email', action.payload.user.email)
      return newState
    case UserTypes.LOG_OUT:
      return state.merge({
        defaultName: '',
        defaultEmail: '',
      })
    case types.SET_NAME:
      return state.merge({name: action.payload.name})
    case types.SET_EMAIL:
      return state.merge({email: action.payload.email})
    case types.SET_MESSAGE:
      return state.merge({message: action.payload.message})
    case types.SEND_MESSAGE:
      return state.merge({
        loadingContact: true,
        showContactSuccessMessage: false,
        error: '',
      })
    case types.SEND_MESSAGE_SUCCESS:
      return state.merge({
        loadingContact: false,
        showContactSuccessMessage: true,
        message: '',
      })
    case types.SEND_MESSAGE_FAIL:
      return state.merge({
        loadingContact: false,
        error: action.payload.error,
      })
    case types.SET_SHOW_CONTACT_SUCCESS_MESSAGE:
      return state.merge({
        showContactSuccessMessage: action.payload.show,
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/help/reducers/help.js